(function (d) {
  var productLabels = [
    { match: 'infrared-pemf-mat',                 label: 'FOR RECOVERY & SLEEP' },
    { match: 'red-light-cap',                     label: 'FOR HAIR GROWTH' },
    { match: 'infrared-sauna-blanket',            label: 'FOR RELAXATION' },
    { match: 'red-light-toothbrush',              label: 'FOR GUM SUPPORT' },
    { match: 'demi-red-light-therapy-device',     label: 'FOR RECOVERY' },
    { match: 'demi-red-light-device-au',     label: 'FOR RECOVERY' },
    { match: 'super-max-red-light-device-au', label: 'FOR FULL BODY RECOVERY' }
  ];

  var productDescriptions = [
    { match: 'infrared-pemf-mat',                    text: 'Advanced full-body recovery and better sleep' },
    { match: 'red-light-cap',                        text: 'Thicker, fuller, and healthier looking hair' },
    { match: 'infrared-sauna-blanket',               text: 'Deep, soothing heat to support relaxation and deep sleep' },
    { match: 'red-light-toothbrush',                 text: 'FDA-cleared to support gum health and oral hygiene' },
    { match: 'demi-red-light-therapy-device',        text: 'Treats muscle and joint pain and recover faster' },
    { match: 'demi-red-light-device-au',        text: 'Treats muscle and joint pain and recover faster' },
    { match: 'super-max-red-light-device-au',   text: 'Full-body recovery and treats muscle and joint pain' },
    { match: 'full-spectrum-light-bulb',             text: 'Support your natural circadian rhythm with better lighting' },
    { match: 'blue-light-blocking-light-bulb',       text: 'Support better sleep with pure red light' },
    { match: 'red-light-neck',                       text: 'Enhance skin appearance in the neck & chest regions' },
    { match: 'red-light-face-wand',                  text: 'Contour and lift your skin with red light and sonic vibration' },
    { match: 'emf-radiation-free-air-tube-headphones-earphones', text: 'Reduce exposure to EMF radiation' }
  ];

  function getSlug(href) {
    var m = (href || '').match(/\/products\/([^\/\?\#]+)/);
    return m ? m[1] : '';
  }

  function findBySlug(list, href, prop) {
    var slug = getSlug(href);
    if (!slug) return null;
    for (var i = 0; i < list.length; i++) {
      if (slug === list[i].match || slug.indexOf(list[i].match) === 0) {
        return list[i][prop];
      }
    }
    return null;
  }

  function addTagline(card) {
    if (card.querySelector('.card__tagline')) return;
    var link = card.querySelector('a.full-unstyled-link');
    if (!link) return;
    var heading = card.querySelector('.card__heading');
    if (!heading) return;
    var label = findBySlug(productLabels, link.getAttribute('href'), 'label');
    if (!label) return;

    var span = d.createElement('span');
    span.className = 'card__tagline';
    span.textContent = label;
    heading.parentNode.insertBefore(span, heading);
  }

  function addDescription(card) {
    if (card.querySelector('.card__desc')) return;
    var link = card.querySelector('a.full-unstyled-link');
    if (!link) return;
    var info = card.querySelector('.card-information');
    if (!info) return;
    var href = link.getAttribute('href');
    var text = findBySlug(productDescriptions, href, 'text');
    if (!text) return;

    // Toothbrush copy varies by market: only US keeps the FDA-cleared phrasing
    var slug = getSlug(href);
    var isUS = d.body.getAttribute('data-bch-market') === 'us';
    if (slug.indexOf('red-light-toothbrush') === 0 && !isUS) {
      text = 'Support better gum health and oral hygiene';
    }

    var p = d.createElement('p');
    p.className = 'card__desc';
    p.textContent = text;
    info.parentNode.insertBefore(p, info);
  }

  function replaceCardBottom(bottom) {
    var wrapper = bottom.closest('.card-wrapper') || bottom.closest('.card');
    var link = wrapper ? wrapper.querySelector('a.full-unstyled-link') : null;
    var href = link ? link.getAttribute('href') : '#';

    bottom.innerHTML = '<a href="' + href + '" class="button button--primary" style="width:100%;margin-top:1.5rem;">SHOP NOW →</a>';
  }

  function init() {
    d.body.classList.add('collection-new');
    d.querySelectorAll('.collection-new .card__content-bottom').forEach(replaceCardBottom);
    d.querySelectorAll('.collection-new .card-wrapper').forEach(function (card) {
      addTagline(card);
      addDescription(card);
    });
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(document);
